import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { ReferenceRoomSettingsService } from './service/reference-room-settings.service';

import { InstallationDetailsStore } from '@store';
import { ReferenceRoomSettingsNoRoomComponent } from './reference-room-settings-no-room/reference-room-settings-no-room.component';
import { ReferenceRoomSettingsManageRoomComponent } from './reference-room-settings-manage-room/reference-room-settings-manage-room.component';
import { ReferenceRoomSettingsAssignRoomComponent } from './reference-room-settings-assign-room/reference-room-settings-assign-room.component';
import { ReferenceRoomSettingsHelper } from './reference-room-settings.helper';

@Component({
  selector: 'app-reference-room-settings-overlay',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    ReferenceRoomSettingsNoRoomComponent,
    ReferenceRoomSettingsManageRoomComponent,
    ReferenceRoomSettingsAssignRoomComponent,
  ],
  templateUrl: './reference-room-settings-overlay.component.html',
  styleUrl: './reference-room-settings-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferenceRoomSettingsOverlayComponent {
  readonly ReferenceRoomSettingsView = ReferenceRoomSettingsHelper.ReferenceRoomSettingsView;
  constructor(
    public rrsService: ReferenceRoomSettingsService,
    public installationDetailsStore: InstallationDetailsStore
  ) {}
}
